﻿import { containerLockTypeAliasesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("container-lock-type-aliases"),
  endpoint: "container-lock-type-aliases",
  operations: containerLockTypeAliasesOps,
  roleView: [ROLE.LOCK_TYPE_ALIAS_VIEW, ROLE.LOCK_TYPE_ALIAS_ADMIN],
  roleAdmin: [ROLE.LOCK_TYPE_ALIAS_ADMIN],
  singularName: (t) => t("Lock Type Alias"),
  name: (t) => t("Lock Type Aliases"),
  syncCustomerFilter: true,
});

export default conf;
